export function getCurrentTimestampMs(): number {
  return new Date().getTime();
}
